const NotifData = [
	{
		key: 0,
		date: new Date('2018', '6', '24', '16', '0'),
		type: 'article',
		text: 'Understanding Operating Systems',
		read: false,
		elementId: 1
	}
]

export default NotifData



// WEBPACK FOOTER //
// ./src/common/fixtures/notifications.js